import { toast } from "react-toastify";
import { GET_APPLICATIONS_LIST_BRANCHWISE, TEAM_OVERVIEW_ERROR, TEAM_OVERVIEW_LOADING, TOKEN_FETCH_ERROR } from "../actionType";
import { getAuthHeaders, getAuthToken } from "../../utils/auth";
import axios from "axios";


export const getApplicationListBranchwise = (filters) => async (dispatch) => {
    try {
        const token = getAuthToken();

        if (!token) {
            dispatch({ type: TOKEN_FETCH_ERROR });
            return;
        }

        dispatch({ type: TEAM_OVERVIEW_LOADING });

        const queryParams = new URLSearchParams();

        if (filters?.date_from) {
            queryParams.append('date_from', filters?.date_from);
        }

        if (filters?.date_to) {
            queryParams.append('date_to', filters?.date_to);
        }

        if (filters?.branch_code) {
            queryParams.append('branch_code', filters?.branch_code);
        }

        let response = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/applications/get-application-list-branch-wise?${queryParams.toString()}`, 
            { headers: getAuthHeaders() }
        );
        // console.log("Response ====>", response?.data?.data);

        dispatch({
            type: GET_APPLICATIONS_LIST_BRANCHWISE,
            payload: response?.data?.data,
        });
    } catch (error) {
        let errorMsg = error?.response?.data?.message;
        dispatch({ type: TEAM_OVERVIEW_ERROR, payload: errorMsg });
        toast.error(errorMsg);
    }
}